const SquareBracketsIcon = ({color, scale}) => {
	return (
		<svg
			width="50"
			height="15"
			viewBox="0 0 40 25"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			transform={scale}
				
			
		>
			<path
				d="M12 24.8998L0 12.8998L12.1 0.799805L14.25 2.9498L4.3 12.8998L14.15 22.7498L12 24.8998ZM27.9 24.9998L25.75 22.8498L35.7 12.8998L25.85 3.0498L28 0.899804L40 12.8998L27.9 24.9998Z"
				fill={color}
			/>
		</svg>
	);
};

export default SquareBracketsIcon;
